import { createSlice } from '@reduxjs/toolkit'
const initialState = {
    queries: null,
    isPending: false,
    error: false,
    data: null,
    originalData: null
}
export const fetchStatusSlice = createSlice({
    name: "fetchStatus",
    initialState,
    reducers: {
        resetFetch: (state) => {
            Object.assign(state, initialState)
        },
        setQueries: (state, action) => {
            state.queries = action.payload
        },
        setIsPending: (state, action) => {
            state.isPending = action.payload
        },
        setError: (state, action) => {
            state.error = action.payload
        },
        setData: (state, action) => {
            state.data = action.payload 
        }
    }
})

export const { resetFetch, setQueries, setIsPending, setError, setData } = fetchStatusSlice.actions
export default fetchStatusSlice.reducer